import { useLayoutEffect, useState, useRef, useMemo } from "react";
import { createUseStyles } from "react-jss";
const queryString = require('query-string');

const useStyles = createUseStyles(theme => ({
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  container: {
    height: "80%",
    width: "80%",
    background: "black",
    position: "fixed",
    zIndex: 1001,
    boxShadow: "2px 0px 16px rgba(0, 0, 0, 0.27)",
    "border-radius": 3,
    left: "10%",
    top: "10%",
    color: "white",
    overflow: "auto",
    animation: "$fadein ease 0.2s",
  },
  backgroundHider: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 10,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  videoBackground: {
    width: "80vw",
    height: "85vw",
    minHeight: "80vh",
    minWidth: "142.2vh",
    position: "absolute",
    border: "none",
    top: "40%",
    left: "40%",
    transform: "translate(-40%,-40%)",
  },
}));

const PreviewVideoModal = ({ onClose, url: backgroundVideo }) => {
  const classes = useStyles();

  const videoContent = useMemo(() => {
    if (!backgroundVideo) return null;
    if (backgroundVideo.includes("vimeo.com")) {
      const videoUrl = (() => {
        const defaultParams = {
          h: "1ec2e1cabe",
          player_id: 0,
          badge: 0,
          app_id: 58479,
          background: 1,
          autoplay: 1,
          loop: 1,
          byline: 0,
          title: 0,
        }
        if (backgroundVideo.includes("player.vimeo.com")) {
          const urlData = new URL(backgroundVideo);
          const params = queryString.parse(urlData.search);
          const combineParams = {
            ...params,
            ...defaultParams,
            h: params.h || defaultParams.h,
            player_id: params.player_id || defaultParams.player_id,
            badge: params.badge || defaultParams.badge,
            app_id: params.app_id || defaultParams.app_id,
          }
          return `${urlData.origin}${urlData.pathname}?${queryString.stringify(combineParams)}`;
        }
        const regex = /vimeo\.com\/(\d+)\//;
        const match = backgroundVideo.match(regex);
        if (match) {
          return `https://player.vimeo.com/video/${match[1]}?${queryString.stringify(defaultParams)}`;
        } else {
          return backgroundVideo;
        }
      })();

      return (
        <iframe
          src={videoUrl}
          allowFullScreen
          className={classes.videoBackground}
          title="video-background"
          allow="autoplay; fullscreen"
        />
      )
    }
    return (
      <video
        autoPlay
        loop
        muted
        className={classes.videoBackground}
        src={backgroundVideo}
      />
    )
  }, [backgroundVideo, classes.videoBackground]);

  return (
    <>
      <div className={classes.container}>
        {videoContent}
      </div>
      <div className={classes.backgroundHider} onClick={onClose} />
    </>
  );
};

export default PreviewVideoModal;
